import { useModuleData } from "@/hooks/useModuleData";
import { Loader } from "@/components/common/Loader";
import { num } from "@/lib/format";

export function CapacityPanel() {
  const { data: wcs, loading } = useModuleData("/work-centers/capacity");
  if (loading || !wcs) return <Loader />;

  return (
    <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3" data-testid="capacity-grid">
      {wcs.map((w) => {
        const over = w.load_pct > 100;
        return (
          <div key={w.wc_code} data-testid={`wc-card-${w.wc_code}`} className="rounded-xl border border-[#e5e9f0] bg-white p-4 shadow-sm">
            <div className="flex items-center justify-between">
              <div><div className="font-mono text-xs text-[#3B82F6]">{w.wc_code}</div><div className="text-[#32363a]">{w.name}</div></div>
              <span className={`font-mono text-sm ${over ? "text-red-600" : "text-emerald-600"}`}>{w.load_pct}%</span>
            </div>
            <div className="mt-3 h-2 rounded bg-[#eef1f5]"><div className={`h-2 rounded ${over ? "bg-red-500" : "bg-[#3B82F6]"}`} style={{ width: `${Math.min(100, w.load_pct)}%` }} /></div>
            <div className="mt-2 flex justify-between text-[11px] text-[#6a6d70]">
              <span>Load {num(w.load_qty)} pcs</span><span>Cap {num(w.capacity_per_day)}/day</span>
            </div>
            <div className="mt-1 text-[11px] text-[#6a6d70]">≈ {w.load_days} production days queued</div>
          </div>);
      })}
      {wcs.length === 0 && <div className="text-[#6a6d70]">No work centres defined.</div>}
    </div>
  );
}
